import { uuid25 } from "../../uuid/dist/uuid25.js";
import { Direction, ReferentialAction, RelationshipType, StartRelationshipType } from "../../constants/schema.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/relationship.entity.ts
var createRelationship = (value) => deepMerge({
	id: uuid25(),
	identification: false,
	relationshipType: RelationshipType.ZeroN,
	startRelationshipType: StartRelationshipType.dash,
	onDelete: ReferentialAction.none,
	onUpdate: ReferentialAction.none,
	start: {
		tableId: "",
		columnIds: [],
		x: 0,
		y: 0,
		direction: Direction.bottom
	},
	end: {
		tableId: "",
		columnIds: [],
		x: 0,
		y: 0,
		direction: Direction.bottom
	}
}, value ?? {});
//#endregion
export { createRelationship };
